var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "url(#paint0_linear_1_644)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 19H20V20.5556H6V19ZM13.7778 11.2222H19.2222L13 17.4444L6.77778 11.2222H12.2222V5H13.7778V11.2222Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_644",
    x1: 14.7105,
    y1: -5.81579,
    x2: 13,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF03CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B0CB2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download-icon.ed1cfa22d8370887e54c533e167c91d1.svg";